
import actionTypes from './actionTypes';

import {
    loadServices
} from '../services/actions';
import { loadEditorial } from '../editorial/actions';
import { loadContacts } from '../contacts/actions';
import { loadProducts } from '../products/actions';
import { loadProductTypes } from '../productTypes/actions';

export const loadAppData = () => async dispatch => {
    try{
        dispatch({type: actionTypes.LOAD_APP_DATA_START});
        
        await dispatch(loadEditorial());
        await dispatch(loadServices());
        await dispatch(loadContacts());
        await dispatch(loadProducts());
        await dispatch(loadProductTypes());

        dispatch({type: actionTypes.LOAD_APP_DATA_SUCCESS});
    } catch(error){
        dispatch({type: actionTypes.LOAD_APP_DATA_FAIL, payload:{error}});
    }
};